import {Component, OnInit} from '@angular/core';
import {Item} from "../../../../../framework/model/core/items/item";
import {ActivatedRoute} from "@angular/router";
import {ModelProvider} from "../../../../../framework/providers/modelProvider/ModelProvider";
import {Events} from "../../../../../framework/providers/events";
import {Observable} from "rxjs";
import {CanComponentDeactivate} from "../../../../components/can-deactivated/can-deactivated.gurad";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";
import {OrderService} from "../../../../services/OrderService";
import {AlertController} from "@ionic/angular";

@Component({
    selector: 'items',
    templateUrl: './items.page.html',
    styleUrls: ['./items.page.scss'],
})
export class ItemsPage implements OnInit, CanComponentDeactivate {

    public options: object = {};
    public filters: object;
    public prefix = 'items_list';

    constructor(public route: ActivatedRoute, public modelProvider: ModelProvider, public events: Events,
                public tools: ModelToolsProvider, public orderService: OrderService) {
    }


    canDeactivate(nextUrl): Observable<boolean> | Promise<boolean> | boolean {
        // Implement your logic here to check if the user can leave the component
        // For example, show a confirmation dialog or perform checks

        return true

        const shouldLeave = nextUrl.includes('cart');

        if (shouldLeave) {
            return true; // User can leave
        } else {
            let action = this.orderService.getCartAction()
            if (!action) return true;

            return new Promise<boolean>((resolve) => {
                this.orderService.cancelOrderAction(action).then((result) => {
                    resolve(result);
                });
            });

            // Example: Show a confirmation dialog
        }
    }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.initItems(JSON.parse(JSON.stringify(params)));
        });
    }

    initItems(filters) {
        filters['setPrefix'] = true;
        this.filters = filters;

    }

    ngAfterViewInit() {
        this.events.publish(this.prefix + '_updateItemsFilter', this.filters);
    }
}
